import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["appearance", "className", "density", "field", "intent", "isDisabled", "onChange", "onUpdate", "name", "shape", "size", "value"];
import * as React from 'react';
import cn from 'classnames';
import { intentClass, ControlSizeType, ControlAppearanceType, ControlShapeType, safeInvoke, controlClasses } from '../../../../library';
export var TextArea = React.forwardRef(function (props, ref) {
  var handleChange = function handleChange(e) {
    var value = e.currentTarget.value;
    safeInvoke(props.onUpdate, props.field, value, e);
    safeInvoke(props.onChange, e);
  };
  var appearance = props.appearance,
    className = props.className,
    density = props.density,
    field = props.field,
    intent = props.intent,
    isDisabled = props.isDisabled,
    onChange = props.onChange,
    onUpdate = props.onUpdate,
    name = props.name,
    shape = props.shape,
    size = props.size,
    value = props.value,
    inputProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn('textarea', controlClasses({
    size: size,
    appearance: appearance,
    shape: shape,
    density: density
  }), intentClass(props.intent), {
    '-disabled': isDisabled,
    '-readonly': inputProps.readOnly
  }, props.className);
  return React.createElement("textarea", _extends({
    className: classNames,
    onChange: handleChange,
    id: field,
    name: !!name ? name : field,
    ref: ref,
    disabled: isDisabled,
    value: value !== null ? value : ''
  }, inputProps));
});
TextArea.defaultProps = {
  shape: ControlShapeType.ROUNDED,
  size: ControlSizeType.MEDIUM,
  appearance: ControlAppearanceType.OUTLINE
};
TextArea.displayName = 'TextArea';